import { Grid } from '@mui/material'
import React from 'react'
import EventSummaryBox from './SummaryBox/EventSummaryBox'
import TaskSummaryBox from './SummaryBox/TaskSummaryBox'

const OverviewSummaryBox = () => {
  return (
    <React.Fragment>
      <Grid container spacing={2} size={12}>
        <Grid size={{ xs: 12, md: 6 }}>
          <EventSummaryBox />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TaskSummaryBox />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

export default OverviewSummaryBox
